// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-audit-record .con {\n  padding-top: 30px;\n  min-height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
